import Content from "@/pages/home";
import Ecological from "@/pages/ecological";
import ApplicationDevelopment from "@/pages/applicationDevelopment";
import EquipmentDevelopment from "@/pages/equipmentDevelopment";
import DocumentResources from "@/pages/documentResources";
import Resource from "@/pages/resource";
import ServiceSupport from "@/pages/serviceSupport";
import Design from "@/pages/design";
import Develop from "@/pages/develop";
import Document from "@/pages/document";
import DesignStory from "@/pages/designStory";
import Staging from "@/pages/staging";
import AppDetail from "@/pages/appDetail";
import Info from "@/pages/appDetail/info";
import New from "@/pages/appDetail/new";
import Old from "@/pages/appDetail/old";
import Profile from "@/pages/appDetail/profile";
import VitePressEmbed from "@/pages/VitePressEmbed";
import VideoPlayer from "@/pages/videoPlayer";
import VideoCollection from "@/pages/videoPlayer/videoCollection";
import VideoCollectionPC from "@/pages/videoPlayer/videoCollection";
import Questions from "@/pages/questions";
import QuestionsDetail from "@/pages/questions/components/questionsDetail";
import FreeDownload from "@/pages/freeDownload";
import TechnicalSupport from "@/pages/TechnicalSupport";
// AI 知识助手，需要放开 http文件的 config.headers.Authorization 后调试 
// import AiHelper from "@/pages/TechnicalSupport/AiHelper/knowledge";
import AiHelper from "@/pages/TechnicalSupport/AiHelper";
import MyProject from "@/pages/TechnicalSupport/FaeProject/MyProject";
import MyOrder from "@/pages/TechnicalSupport/FaeProject/MyOrder";
import LinkQuestionsDetail from "@/pages/questions/components/LinkQuestionsDetail";
import SystemActivite from "@/pages/Activite/SystemActivite";
import ActiviteSignUp from "@/pages/Activite/SystemActivite/ActiviteSignUp";
import SubmitOrder from "@/pages/TechnicalSupport/FaeProject/SubmitOrder";
import OrderDetail from "@/pages/TechnicalSupport/FaeProject/OrderDetail";
import X86 from "@/pages/x86";
import X86Obtain from "@/pages/x86/obtain";
import Notice from "@/pages/notice";
import Faq from "@/pages/faq";
import UserCenter from "@/pages/userCenter";
import UserInfo from "@/pages/userCenter/components/UserInfo";
import MyCollect from "@/pages/userCenter/components/myCollect";
import MyFollow from "@/pages/userCenter/components/MyFollow";
import MyQuestion from "@/pages/userCenter/components/MyQuestion";
import BrowseRecords from "@/pages/userCenter/components/BrowseRecords";
import { Navigate } from "react-router-dom";
import { publicPath } from "@/utils/base";
import Certificate from "@/pages/Certificate";

const x86CanonicalPath = `${String(publicPath).replace(/\/$/, "")}/x86`;
const x86ObtainCanonicalPath = `${x86CanonicalPath}/obtain`;

const Home = [
  {
    name: "",
    path: "",
    component: <Content />,
  },
  // {
  //   name: "Home",
  //   path: "home",
  //   component: <Content />,
  // },
  {
    name: "Ecological",
    path: "ecological",
    component: <Ecological />,
  },
  {
    name: "ApplicationDevelopment",
    path: "applicationDevelopment",
    component: <ApplicationDevelopment />,
  },
  {
    name: "EquipmentDevelopment",
    path: "equipmentDevelopment",
    component: <EquipmentDevelopment />,
  },
  {
    name: "KaihongOsGuides",
    path: "wikiKaihongosGuides",
    component: <VitePressEmbed />,
  },
  {
    name: "DocumentResources",
    path: "document_resources",
    component: <DocumentResources />,
  },
  {
    name: "Resource",
    path: "resource",
    component: <Resource />,
  },
  {
    name: "ServiceSupport",
    path: "service_support",
    component: <ServiceSupport />,
  },
  // {
  //   name: "Design",
  //   path: "design",
  //   component: <Design />,
  // },
  // {
  //   name: "Develop",
  //   path: "develop",
  //   component: <Develop />,
  // },
  // {
  //   name: "Document",
  //   path: "document",
  //   component: <Document />,
  // },
  // {
  //   name: "DesignStory",
  //   path: "design_story",
  //   component: <DesignStory />,
  // },

  // Warning: Staging模块在移动端 iphone8、8plus 会出现白屏
  //   {
  //     name: "Staging",
  //     path: "staging",
  //     component: <Staging />,
  //   },
  {
    name: "AppDetail",
    path: "app_detail",
    component: <AppDetail />,
    children: [
      {
        name: "Info",
        path: "info/:type/:id",
        component: <Info />,
      },
      {
        name: "New",
        path: "new/:type/:id",
        component: <New />,
      },
      {
        name: "Old",
        path: "old/:type/:id",
        component: <Old />,
      },
      {
        name: "Profile",
        path: "profile/:type/:id",
        component: <Profile />,
      },
    ],
  },
  {
    name: "videoPlayer",
    path: "videoPlayer",
    component: <VideoPlayer />,
  },
  {
    name: "videoCollection",
    path: "videoPlayer/videoCollection",
    component: <VideoCollection />,
  },
  {
    name: "videoCollection",
    path: "video/pc",
    component: <VideoCollectionPC />,
  },
  {
    name: "videoCollection",
    path: "video/fly",
    component: <VideoCollectionPC />,
  },
  {
    name: "technicalSupport",
    path: "technicalSupport",
    component: <TechnicalSupport />,
    children:[
      {
        name: "notice",
        path: "notice",
        component: <Notice />,
      },
      {
        name: "feedback",
        path: "feedback",
        component: <Questions />,
      },
      {
        name: "faq",
        path: "faq",
        component: <Faq />,
      },
      {
        name: "certificate",
        path: "certificate",
        component: <Certificate />,
      },
      {
        name: "ai",
        path: "ai",
        component: <AiHelper />,
      },
      {
        name: "project",
        path: "fae/project",
        component: <MyProject />,
      },
      {
        name: "order",
        path: "fae/order",
        component: <MyOrder />,
      },
      {
        name: "submitOrder",
        path: "fae/order/submit",
        component: <SubmitOrder />,
      },{
        name: "orderDetail",
        path: "fae/order/detail",
        component: <OrderDetail />,
      },
      {
        name: "noticeDetail",
        path: "noticeDetail/:id",
        component: <QuestionsDetail />,
      },
      {
        name: "feedbackDetail",
        path: "feedbackDetail/:id",
        component: <QuestionsDetail />,
      },
      {
        name: "faqDetail",
        path: "faqDetail/:id",
        component: <QuestionsDetail />,
      },
    ]
  },{
    name: "questionsDetail",
    path: "questionsDetail/:id",
    component: <LinkQuestionsDetail />,
  },
  {
    name: "KaihongOS桌面版x86获取",
    path: "x86/obtain",
    component: <X86Obtain />,
  },
  {
    name: "KaihongOS桌面版x86获取-legacy",
    path: "X86/obtain",
    component: <Navigate to={x86ObtainCanonicalPath} replace />,
  },
  {
    name: "KaihongOS桌面版x86",
    path: "x86",
    component: <X86 />,
  },
  {
    name: "KaihongOS桌面版x86-legacy",
    path: "X86",
    component: <Navigate to={x86CanonicalPath} replace />,
  },
  {
    name: "x86活动详情",
    path: "activity/x86-beta",
    component: <SystemActivite />,
  },{
    name: "x86活动报名",
    path: "activity/x86-beta/signup",
    component: <ActiviteSignUp />,
  },{
    name: "/kaihong-developer-documents/kaihongos-guides",
    path: "document/kaihong-developer-documents/kaihongos-guides/",
    component: <Document />,
    children:[
      {
        name: "文档内容",
        path: "*",
        component: <></>,
      }
    ]
  },
  {
    name: "UserCenter",
    path: "user-center",
    component: <UserCenter />,
    children: [
      {
        name: "userInfo",
        path: "user-info",
        component: <UserInfo />,  
      },
      {
        name: "myCollect",
        path: "my-collect",
        component: <MyCollect />,
      },
      {
        name: "myFollow",
        path: "my-follow",
        component: <MyFollow />,
      },
      {
        name: "myQuestion",
        path: "my-question",
        component: <MyQuestion />,
      },
      {
        name: "browseRecords",
        path: "browse-records",
        component: <BrowseRecords />,
      },
    ]
  },
  {
    name: 'userDetail',
    path: 'user-detail/:userId',
    component: <UserInfo />,
  }
];

export default Home;
